/**
 * Collects all values from an (async) iterable and returns them as an array
 */
export default async function all(source) {
    const arr = [];
    for await (const entry of source) {
        arr.push(entry);
    }
    return arr;
}
//# sourceMappingURL=index.js.map